import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/api";

export const getLogin = createAsyncThunk("auth/getLogin", async (loginData) => {
  const { data } = await api.login(loginData);
  // ocekujemo data[0] s tokenom itd.
  return data[0];
});

// inicijalizacija iz localStorage (ako postoji)
const savedToken = localStorage.getItem("token") || "";
const savedUsername = localStorage.getItem("username") || "";
const savedIntegraInfo = localStorage.getItem("integra_info") || "";

const initialState = {
  token: savedToken,
  username: savedUsername,
  integraInfo: savedIntegraInfo,
  error: "",
  loading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken(state, action) {
      state.token = action.payload;
      localStorage.setItem("token", action.payload || "");
    },
    setUsername(state, action) {
      state.username = action.payload || "";
      localStorage.setItem("username", state.username);
    },
    logout(state) {
      state.token = "";
      state.username = "";
      state.integraInfo = "";
      state.error = "";
      state.loading = false;
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      localStorage.removeItem("integra_info");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLogin.pending, (state) => {
        state.error = "";
        state.loading = true;
      })
      .addCase(getLogin.fulfilled, (state, action) => {
        state.loading = false;

        if ("token_id" in action.payload) {
          state.error = "";
          state.token = action.payload.token_id;

          // uzmi username iz payloada ako API vraca, inace iz poslanog argumenta (login forme)
          const fromPayload = action.payload.username || action.payload.user || "";
          const fromArgs = action.meta?.arg?.username || "";
          state.username = fromPayload || fromArgs;
          state.integraInfo = action.payload.integra_info || "";

          // persist
          localStorage.setItem("token", state.token || "");
          localStorage.setItem("username", state.username || "");
          localStorage.setItem("integra_info", state.integraInfo);
        } else {
          state.error = "Incorrect username or password";
          state.token = "";
          state.username = "";
          state.integraInfo = "";
          localStorage.removeItem("token");
          localStorage.removeItem("username");
          localStorage.removeItem("integra_info");
        }
      })
      .addCase(getLogin.rejected, (state) => {
        state.loading = false;
        state.error = "Incorrect username or password";
        state.token = "";
        state.username = "";
        state.integraInfo = "";
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        localStorage.removeItem("integra_info");
      });
  },
});

export const { setToken, setUsername, logout } = authSlice.actions;

export const authSelector = (state) => state.auth;

export default authSlice.reducer;
